module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3f4b0c31b7b15d65d7e8fd32489c07c7.png";